import React from 'react'
import { useNavigate } from 'react-router-dom'

const ThankYouPageReview = () => {
    const navigate=useNavigate()
    const gotoDashboard=()=>{
        navigate('/dashboard')
    }
    return (
        <div className={`review-main-div thank-you-main-div`}>
            <div>
                <img src='/assets/images/OHC-Logo.png' />
            </div>
            <div>
                <p>
                    Thank you for your review!
                </p>
            </div>
            <div className='red-underline' onClick={gotoDashboard}>
                <p>
                    Book a Cleaning Service
                </p>
            </div>
        </div>
    )
}

export default ThankYouPageReview